import JraEncodeDecodeModule from './JraEncodeDecodeModule';
import { leaveFloat } from '../../../../util/regex';
import {
  SECTION_EXPANDED_CLASS,
} from '../constants';

export default class JraAssociate extends JraEncodeDecodeModule {
  static ASSOCIATE_TOGGLE_EVENT = 'associateToggleEvent';

  static ASSOCIATE_ADD_EVENT = 'associateAddEvent';

  static ASSOCIATE_REMOVE_EVENT = 'associateRemoveEvent';

  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);

    this.element = element;

    this.initJraAssociate();
  }

  initJraAssociate() {
    if (this.element) {
      this.associateMemberComponent = this.element.querySelector('[data-jra-form-associate-cost]');
      const key = this.associateMemberComponent.dataset.jraFormAssociateTitle;
      const value = parseFloat(
        leaveFloat(this.associateMemberComponent.dataset.jraFormAssociateCost),
      );

      // add associate member cost to payment summary on page load for renew form
      // ensure runs after stack end to pick up any listeners immediately added.
      setTimeout(() => {
        if (this.associateMemberComponent.classList.contains(SECTION_EXPANDED_CLASS)) {
          this.emit(JraAssociate.ASSOCIATE_REMOVE_EVENT, { key, value });
          this.emit(JraAssociate.ASSOCIATE_ADD_EVENT, { key, value });
          this.emit(JraAssociate.ASSOCIATE_TOGGLE_EVENT);
        }
      }, 0);

      const associateMemberObserver = new MutationObserver((mutations) => {
        [...mutations].forEach(() => {
          if (this.associateMemberComponent.classList.contains(SECTION_EXPANDED_CLASS)) {
            this.emit(JraAssociate.ASSOCIATE_ADD_EVENT, { key, value });
          } else {
            this.emit(JraAssociate.ASSOCIATE_REMOVE_EVENT, { key, value });
          }
          this.emit(JraAssociate.ASSOCIATE_TOGGLE_EVENT);
        });
      });
      associateMemberObserver.observe(this.associateMemberComponent, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }
}
